function GetUrl(){
    const data = 'https://plastikmp.linezdesignz.ca';
    return data;
  }
  
  export default GetUrl;